"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_dom_1 = require("react-dom");

var Icon_1 = tslib_1.__importDefault(require("../../../Icon"));

var styles = tslib_1.__importStar(require("./ImageSwiperDialog.style"));

var ImageSwiper_1 = tslib_1.__importDefault(require("./ImageSwiper"));

function ImageSwiperDialog(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      isOpen = _ref.isOpen,
      setClickedImageIndex = _ref.setClickedImageIndex,
      title = _ref.title,
      provider = _ref.provider,
      imageUrls = _ref.imageUrls,
      initialSlide = _ref.initialSlide;

  var handleClick = function handleClick() {
    setClickedImageIndex(-1);
    var bodyEl = document.querySelector('body');

    if (bodyEl !== null) {
      bodyEl.style.overflow = 'auto';
    }
  };

  react_1.useEffect(function () {
    var bodyEl = document.querySelector('body');

    if (bodyEl === null) {
      return;
    }

    if (isOpen) {
      bodyEl.style.overflow = 'hidden';
    }
  }, [isOpen]);
  return react_dom_1.createPortal(jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: styles.container
  }, {
    children: [jsx_runtime_1.jsx(ImageSwiper_1.default, {
      title: title,
      provider: provider,
      imageUrls: imageUrls,
      initialSlide: initialSlide
    }, void 0), jsx_runtime_1.jsx(Icon_1.default, {
      css: styles.closeBtn,
      name: "ic_close_xl_white",
      onClick: handleClick
    }, void 0)]
  }), void 0), document.body);
}

exports.default = ImageSwiperDialog;